import { darken, lighten } from 'polished';
import styled from 'styled-components';

import { A, standardFocusStyles } from '@main/pc-core-components';
import { responsive, sp } from '@main/theme';
import { colorIsLight } from '@main/theme-types';

/**
 * The Asset Wrapper
 * TODO: maybe not be the best image-manipulating attributes but it does work at the moment
 * For instance the commented out code below seemed to do the identical thing
 */
export const AssetWrapper = styled.img`
  width: 100%;
  height: 100%;
  /** Default styling assuming hard-edged photo */
  object-fit: cover;
  /** Override with theme styles */
  ${({ theme }) => theme.componentStyles.hero};
`;

/**
 * The Description Wrapper
 */
export const DescriptionWrapper = styled.p`
  color: ${({ theme }) => theme.colors.textOnHero};
  margin: ${sp(2)} 0 ${sp(2.5)} 0;
`;

/**
 * The Text Wrapper
 */
export const TextWrapper = styled.div`
  margin-bottom: ${sp(2)};
  padding: ${sp(4)} ${sp(3.25)};

  ${responsive.atLeastTablet} {
    margin-right: ${sp(1)};
    margin-bottom: 0;
    padding: ${sp(6)} ${sp(4.5)};
  }

  ${responsive.atLeastDesktop} {
    margin-right: 0;
    padding: ${sp(7)};
  }
`;

/**
 * The Title Wrapper
 */
export const TitleWrapper = styled.h1`
  color: ${({ theme }) => theme.colors.textOnHero};
`;

/**
 * The About Transcend Wrapper
 */
export const AboutTranscendWrapper = styled(A)`
  color: ${({ theme }) => theme.colors.textOnHero};
  border-radius: ${sp(0.5)};
  transition: all 0.2s;

  &:hover {
    color: ${({ theme }) =>
      colorIsLight(theme.colors.textOnHero)
        ? darken(0.1, theme.colors.textOnHero)
        : lighten(0.1, theme.colors.textOnHero)};
  }

  &:focus {
    ${standardFocusStyles}
  }
`;

/**
 * The Hero wrapper
 */
export const HeroWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.heroBg};

  ${responsive.atLeastTablet} {
    height: 450px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 100%;
    column-gap: ${sp(1)};
  }

  ${responsive.atLeastDesktop} {
    height: 560px;
  }

  ${responsive.atLeastLargeScreen} {
    height: 40vh;
  }

  /** Override with theme styles */
  ${({ theme }) => theme.componentStyles.heroBackground};
`;
